import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";

interface PalletsData {
  palletdata: {
    load: boolean;
    data: [];
  };
}

export const palletdataSlice = createSlice({
  name: "palletdata",
  initialState: {
    palletdata: {
      load: false,
      data: [],
    },
  } as PalletsData,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchPalletsData.pending, (state: PalletsData) => {
        state.palletdata.load = true;
      })
      .addCase(fetchPalletsData.fulfilled, (state: PalletsData, action: any) => {
        state.palletdata.data = action.payload;
        state.palletdata.load = false;
      })
      .addCase(fetchPalletsData.rejected, (state: PalletsData) => {
        state.palletdata.load = false;
      })
  },
});

export default palletdataSlice.reducer;

export const fetchPalletsData = createAsyncThunk(
  "PalleteManagment/fetchPalletsData",
  async (param: {apiParam: {layout_id: any, warehouse_id: any, rack_pin: any}}, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/getPalletsData", {
        warehouse_id: param.apiParam.warehouse_id,
        layout_id: param.apiParam.layout_id,
        rack_pin: param.apiParam.rack_pin,
      });
      thunkAPI.dispatch(toggleLoading());
      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);